import Chart from 'chart.js/dist/Chart.min';
import { fetchStatistics } from './../api/api';
import appState from './../constants';
import formatNumber from './../helpers/formatters/formatNumber';

/**
 *
 */
function resetSelectedTeam() {
  $('.statistics-by-team-shield').html('');
  $('.statistics-by-team-icon').removeClass('is-hidden');
  $('.statistics-by-team-list-teams').removeClass('has-team-selected');
}

/**
 * @param {Object} data Data
 */
function updateTransactionsTotals(data) {
  const $container = $('.statistics-totals-transactions');
  $container.find('.stats-total-value').html(formatNumber(data.total_transacoes));
  $container.find('.stats-total-situation-arriving').html(formatNumber(data.chegando.total));
  $container.find('.stats-total-situation-leaving').html(formatNumber(data.saindo.total));

  $container.find('.chart-numbers .arriving-value').html(`${data.chegando.percentual}%`);
  $container.find('.chart-numbers .leaving-value').html(`${data.saindo.percentual}%`);
}

/**
 * @param {Object} data Data
 */
function updateVotes(data) {
  const $container = $('.statistics-totals-votes');
  $container.find('.stats-total-value').html(formatNumber(data.total_votos));
  $container.find('.single-stats-total-user-positive .stats-total-user-value').html(formatNumber(data.like.total));
  $container.find('.single-stats-total-user-negative .stats-total-user-value').html(formatNumber(data.dislike.total));

  $container.find('.chart-numbers .like-value').html(`${data.like.percentual}%`);
  $container.find('.chart-numbers .dislike-value').html(`${data.dislike.percentual}%`);
}

/**
 * @param {Object} data Data
 */
function updateTransactionsByStatus(data) {
  const $rowsContainer = $('.stat-by-status-rows-container');
  const transactionsAndStatuses = data.map((status) => { // eslint-disable-line
    return `
      <div class="stat-by-status-row">
        <div class="status-row-details">
          <div class="stat-by-status-icon-container">
            <img src="${status.status.icone.url}" class="stat-by-status-icon">
          </div>
          <div class="stat-by-status-label">${status.status.nome}</div>
          <div class="stat-by-status-value">${status.total}</div>
        </div>
        <div class="stat-by-status-bar">
          <div class="stat-by-status-bar-fill" style="width: ${status.percentual}%">
            <div class="stat-by-status-bar-value">${status.percentual}%</div>
          </div>
        </div>
      </div>
    `;
  }).join('');

  $rowsContainer.html(transactionsAndStatuses);
}

/**
 * @param {Object} data Data
 * @returns {String}
 */
function getSinglePlayerRow(data) {
  return `
    <div class="statistics-by-user-row">
      <div class="player-profile">
        <img src="${data.transacao.atleta_projeto.foto}" alt="" class="player-profile-image">
      </div>
      <div class="player-all-details">
        <div class="player-details">
          <div class="player-details-name">${data.transacao.atleta_projeto.nome}</div>
          <div class="player-details-position">${data.transacao.atleta_projeto.posicao_sigla}</div>
        </div>
        <div class="player-data-details">
          <div class="player-situation">${data.transacao.situacao === 1 ? 'Chegando' : 'Saindo'}</div>
          <div class="player-details-team">
            <img src="${data.transacao.clube_projeto.escudo}" class="player-details-team-shield">
            <div class="player-details-team-name">${data.transacao.clube_projeto.sigla}</div>
          </div>
          <div class="player-details-value">${formatNumber(data.votos)}</div>
        </div>
      </div>
    </div>
  `;
}

/**
 * @param {Object} data Data
 */
function updateTransactionsRanking(data) {
  $('.empty-transactions').removeClass('is-visible');
  const $container = $('.statistics-by-user-feedback');
  const $likeColumn = $container.find('.statistics-by-user-column-approved');
  const $dislikeColumn = $container.find('.statistics-by-user-column-reproved');

  if (!data.mais_aprovadas.length && !data.mais_reprovadas.length) {
    $('.empty-transactions').addClass('is-visible');
  }

  $likeColumn.find('.statistics-by-user-rows').html(data.mais_aprovadas.map(row => getSinglePlayerRow(row)).join(''));
  $dislikeColumn.find('.statistics-by-user-rows').html(data.mais_reprovadas.map(row => getSinglePlayerRow(row)).join(''));
}

/**
 * @param {Object} element canvasElement
 * @param {Array} colors colors
 * @param {Array} numbers data
 */
function createSinglePieChart({ element, colors, numbers }) {
  const ctx = element.getContext('2d');

  const data = {
    datasets: [
      {
        fill: true,
        backgroundColor: colors,
        data: numbers,
        borderWidth: [2, 2],
      },
    ],
  };

  const newChart = new Chart(ctx, { // eslint-disable-line
    type: 'pie',
    data,
    options: {
      aspectRatio: 1,
      tooltips: {
        enabled: false,
      },
    },
  });
}

/**
 * @param {Object} transacoes transacoes
 * @param {Object} votos votos
 */
function createCharts(transacoes, votos) {
  const { chegando, saindo } = transacoes;
  const { like, dislike } = votos;

  const firstChart = {
    element: $('.stats-transaction-totals-chart')[0],
    colors: ['#eab525', '#22791a'],
    numbers: [saindo.percentual, chegando.percentual],
  };
  createSinglePieChart(firstChart);

  const secondChart = {
    element: $('.stats-votes-totals-chart')[0],
    colors: ['#9a1111', '#22791a'],
    numbers: [dislike.percentual, like.percentual],
  };
  createSinglePieChart(secondChart);
}

/**
 * @param {Object} event Event object
 * @param {Number} teamID Team ID
 */
export async function buildStatisticsPage(event = null, teamID = undefined) {
  const $statisticsTabContent = $('.single-tab-content-statistics');
  const vaivemID = $('[data-project]').attr('data-project');
  const $loadingContainer = $statisticsTabContent.find('.loading-statistics-container');
  $loadingContainer.removeClass('is-hidden');

  try {
    const statisticIsCached = appState.generalStatistics;
    let estatisticas = {};

    if (!statisticIsCached && !teamID) {
      estatisticas = (await fetchStatistics(vaivemID, teamID)).estatisticas;
      appState.generalStatistics = estatisticas;
    } else if (teamID) {
      estatisticas = (await fetchStatistics(vaivemID, teamID)).estatisticas;
    } else {
      estatisticas = appState.generalStatistics;
    }

    const { transacoes, votos, status, ranking } = estatisticas;
    $loadingContainer.addClass('is-hidden');

    updateTransactionsTotals(transacoes);
    updateVotes(votos);
    updateTransactionsByStatus(status);
    updateTransactionsRanking(ranking);
    createCharts(transacoes, votos);
    setTimeout(() => {
      $('.tabs-content')[0].slick.setPosition();
    }, 200);
  } catch (error) {
    if (teamID) {
      $('.error-notification-modal').addClass('is-visible');
      setTimeout(() => {
        $('.error-notification-modal').removeClass('is-visible');
        $loadingContainer.addClass('is-hidden');
      }, 1000);
    }
    throw error;
  }
}

/**
 *
 */
export async function showTeamsList() {
  const $teamListMenu = $(this).closest('.statistics-by-team-list-teams-container').find('.teams-list-menu');
  const menuIsActive = $teamListMenu.hasClass('active');
  const hasTeamSelected = $('.statistics-by-team-list-teams').hasClass('has-team-selected');

  let teamsToInsert = '';

  if (hasTeamSelected) {
    teamsToInsert = `
      <div class="remove-selected-shield escudo">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 248.6 257.9">
          <path d="M124.4 24.3l101.5 32.9c0 129.3-101.5 178.2-101.5 178.2S22.9 186.5 22.9 57.2l101.5-32.9m0-13.6c-1.4 0-2.7.3-4.1.7L18.9 44.3c-5.4 1.7-9.5 7.1-9.5 12.9 0 70.9 29.5 119.1 54.3 146.6 26.8 30.2 54 43.1 55 43.8 1.7 1 3.7 1.4 5.8 1.4s4.1-.3 5.8-1.4c1-.7 28.2-13.6 55-43.8 24.8-27.5 54.3-75.7 54.3-146.6 0-5.8-3.7-11.2-9.5-12.9L128.5 11.4c-1.4-.7-2.7-.7-4.1-.7z"  fill="currentColor" />
          <path d="M124.3 46.8c42.8.7 73.5 34 73.9 73.9.4 40.6-33 74-73.6 74.1-40.5.2-73.7-33-74-73.8-.2-40.5 33-74 73.7-74.2zM80.6 149.2l72-72.3c-16.4-12.3-45.4-12.3-64.5 6.1-17.7 17.1-21.2 46.3-7.5 66.2zm16.1 15.9c19.6 13.5 48.2 10.3 65.4-7.8 17.9-18.9 18.6-46.5 6.3-64.3-23.8 24-47.7 48.1-71.7 72.1z" fill="currentColor" />
        </svg>
      </div>
    `;
    teamsToInsert += appState.teamsInMenu
      .filter(team => Number(team.id) !== Number($('.statistics-by-team-shield .escudo').attr('data-team-id')))
      .map(team => `<img src="${team.shield}" data-escudo="${team.shield}" data-name="${team.name}" data-team-id="${team.id}" class="escudo" />`).join('');
  } else {
    teamsToInsert += appState.teamsInMenu.map(team => `<img src="${team.shield}" data-escudo="${team.shield}" data-name="${team.name}" data-team-id="${team.id}" class="escudo" />`).join('');
  }

  if (menuIsActive) {
    $teamListMenu.removeClass('active');
  } else {
    $teamListMenu.html(teamsToInsert);
    $teamListMenu.addClass('active');
  }
}

/**
 * @param {Object} event Event object
 */
export async function showTeamStatistics(event) {
  const isToRemoveSelectedShield = $(event.target).hasClass('remove-selected-shield');
  const isToRemoveSelectedShieldChildren = $(event.target).closest('.remove-selected-shield').length;

  $('.statistics-by-team-list-teams-container .teams-list-menu').removeClass('active');

  if (isToRemoveSelectedShield || isToRemoveSelectedShieldChildren) {
    resetSelectedTeam();
    await buildStatisticsPage();
    $('.statistics-title').html('Estatísticas gerais');
  } else {
    try {
      await buildStatisticsPage(null, $(this).attr('data-team-id'));

      const teamName = $(this).attr('data-name');
      const teamID = $(this).attr('data-team-id');
      const teamShield = $(this).attr('data-escudo');
      const teamShieldElement = `<img src="${teamShield}" data-escudo="${teamShield}" data-name="${teamName}" data-team-id="${teamID}" class="escudo" />`; // eslint-disable-line
      $('.statistics-title').html(teamShieldElement + teamName);

      $('.statistics-by-team-shield').html($(this)[0]);
      $('.statistics-by-team-icon').addClass('is-hidden');
      $('.statistics-by-team-list-teams').addClass('has-team-selected');
    } catch (error) {
      throw error;
    }
  }
}



// WEBPACK FOOTER //
// local_static/templates/vai_vem/2018/assets/scripts/components/statistics.js